import { render, staticRenderFns } from "./wksWbjhDialog.vue?vue&type=template&id=7aceb4f8&"
import script from "./wksWbjhDialog.vue?vue&type=script&lang=js&"
export * from "./wksWbjhDialog.vue?vue&type=script&lang=js&"
import style0 from "./wksWbjhDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports